var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Dimmer, Loader, Message, Table } from "semantic-ui-react";
import { API_SVC_BASE_URL } from "../Config";
import { getWithAuthn } from "../RequestHelpers";
var AmplifierLabelTable = /** @class */ (function (_super) {
    __extends(AmplifierLabelTable, _super);
    function AmplifierLabelTable(props) {
        var _this = _super.call(this, props) || this;
        _this.renderRows = function (rows) {
            var total = rows.map(function (r) { return r.pmols.reduce(function (accum, value) { return accum + value; }); })
                .reduce(function (accum, value) { return accum + value; });
            return rows.map(function (r, index) { return React.createElement(Table.Row, { key: index },
                React.createElement(Table.Cell, null, r.amplifier.id),
                r.pmols.map(function (pmols, pmolIndex) {
                    var alpha = pmols / total;
                    var text = pmols > 0 ? "" + pmols : '-';
                    return React.createElement(Table.Cell, { style: { 'background': "rgba(150, 150, 150, " + alpha + ")" }, key: pmolIndex }, text);
                })); });
        };
        _this.loadReport = function () {
            _this.setState({ loading: true }, function () {
                getWithAuthn(_this.props.urlPath)
                    .then(function (resp) {
                    if (resp.ok) {
                        return resp.json();
                    }
                    else {
                        return undefined;
                    }
                })
                    .then(function (resp) {
                    if (resp === undefined) {
                        _this.setState({
                            loading: false,
                            error: true
                        });
                    }
                    else {
                        _this.setState({
                            error: false,
                            loading: false,
                            response: resp
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't load report: " + rej);
                });
            });
        };
        _this.state = {
            loading: false,
            error: false
        };
        return _this;
    }
    AmplifierLabelTable.prototype.render = function () {
        return React.createElement(Dimmer.Dimmable, { className: 'amplifier-label-report' },
            React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                React.createElement(Loader, null)),
            this.state.error &&
                React.createElement(Message, { negative: true }, "Report could not be loaded."),
            this.state.response &&
                React.createElement(React.Fragment, null,
                    React.createElement("p", null, "Amounts in pmols."),
                    React.createElement(Table, { celled: true },
                        React.createElement(Table.Header, null,
                            React.createElement(Table.Row, null,
                                React.createElement(Table.HeaderCell, null),
                                this.state.response.labelNames.map(function (l, index) { return React.createElement(Table.HeaderCell, { key: index }, l); }))),
                        React.createElement(Table.Body, null, this.renderRows(this.state.response.rows))),
                    React.createElement("div", null,
                        React.createElement("a", { href: API_SVC_BASE_URL + "/" + this.props.urlPath + "?format=csv" },
                            React.createElement(Button, { icon: 'download', label: 'Download csv', labelPosition: 'left' })))));
    };
    AmplifierLabelTable.prototype.componentDidMount = function () {
        this.loadReport();
    };
    return AmplifierLabelTable;
}(React.PureComponent));
export default AmplifierLabelTable;
//# sourceMappingURL=AmplifierLabelTable.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/AmplifierLabelTable.js
// module id = 1450
// module chunks = 0